import { render } from "./IconSquareRegular.vue?vue&type=template&id=0d94bb5a"
const script = {}

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__